import { useEffect } from 'react';

export default function Refund() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-black pt-32 pb-20 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Política de Reembolso</h1>
                <div className="text-gray-300 space-y-6 leading-relaxed">

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">1. Garantia de Satisfação ou Reembolso</h2>
                        <p>Oferecemos uma garantia de reembolso de 7 dias para todas as nossas novas subscrições. Se não estiver satisfeito com o nosso serviço, pode solicitar um reembolso completo.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">2. Condições de Elegibilidade</h2>
                        <p>Para ser elegível ao reembolso:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>A solicitação deve ser feita nos 7 dias seguintes à compra.</li>
                            <li>Deve ter contactado o nosso suporte técnico para tentar resolver os eventuais problemas encontrados.</li>
                            <li>O problema não deve provir da sua própria ligação à internet (velocidade insuficiente).</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">3. Procedimento de Solicitação</h2>
                        <p>Para solicitar um reembolso, envie um e-mail para support@tv4klive.com com o seu número de encomenda e o motivo da sua solicitação. A nossa equipa processará a sua solicitação em 24 a 48 horas.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-yellow-400 mb-4">4. Prazos de Reembolso</h2>
                        <p>Uma vez aprovado o reembolso, os fundos serão creditados no seu método de pagamento inicial em 5 a 10 dias úteis, consoante o seu banco.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
